import { Component, inject } from '@angular/core';
import { GS1ButtonDirective, GS1CardComponent, GS1ChipColor, GS1ChipComponent } from '@gs1france/gs1-components-library';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TagsService } from '../../core/services/tags.service';

@Component({
  selector: 'app-home-formations',
  imports: [GS1ButtonDirective, GS1ChipComponent, GS1CardComponent, TranslateModule],
  templateUrl: './home-formations.component.html',
  styleUrl: './home-formations.component.scss'
})
export class HomeFormationsComponent {
  private tagsService = inject(TagsService);
  private translateService = inject(TranslateService);

  formationsLink = 'https://www.gs1.fr/formations-conseil-qualite/formez-vous-aux-standards-gs1';

  formations = [
    {
      title: 'home.formations.cards.identification.title',
      description: 'home.formations.cards.identification.description',
      chip: 'home.formations.cards.identification.chip',
      color: 'pale-blue' as GS1ChipColor,
      button: 'home.formations.cards.identification.button',
      link: 'https://www.gs1.fr/formation/identifiez-vos-produits-facilement-grace-code-unique-international'
    },
    {
      title: 'home.formations.cards.engagement.title',
      description: 'home.formations.cards.engagement.description',
      chip: 'home.formations.cards.engagement.chip',
      color: 'pale-blue' as GS1ChipColor,
      button: 'home.formations.cards.engagement.button',
      link: 'https://www.gs1.fr/formation/amplifiez-lengagement-consommateur-votre-marque-grace-au-qr-code-augmente-gs1'
    },
    {
      title: 'home.formations.cards.data.title',
      description: 'home.formations.cards.data.description',
      chip: 'home.formations.cards.data.chip',
      color: 'pale-blue' as GS1ChipColor,
      button: 'home.formations.cards.data.button',
      link: 'https://www.gs1.fr/formation/partagez-vos-donnees-grace-fiche-produit-dematerialisee-gs1-reseau-gdsn'
    }
  ];

  trackFormation(title?: string): void {
    this.tagsService.sendEvent('formation', { formation_name: title ? this.translateService.instant(title) : 'Toutes nos formations' });
  }
}
